import React from "react";
import "./LoadingSpinner.css";

function LoadingSpinner() {
    return (
        <div className="loader__container">
            <div className="loader">Loading...</div>
        </div>
    )
}

export default LoadingSpinner;